export * from './DetailsTable'